import { Box, Skeleton, Typography } from '@mui/material';
import { TagContainer } from 'components';

const EmptyTag = () => {
	return (
		<>
			<TagContainer
				tagContent={
					<>
						<Box
							pl={1}
							sx={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start',
							}}
						>
							<Typography
								variant="subtitle2"
								sx={{ color: 'black', width: '90%' }}
								p={0.5}
								pb={0}
							>
								<Skeleton animation="wave" />
							</Typography>
							<Typography
								variant="caption"
								sx={{ color: '#21BF91', width: '50%' }}
								p={0.5}
							>
								<Skeleton animation="wave" />
							</Typography>
						</Box>
					</>
				}
				afterSize={3}
				imgSkeleton={true}
				imgPlaceHolder
			/>
		</>
	);
};

export default EmptyTag;
